import { Configuration, OpenAIApi } from 'openai';

import FormSection from './components/FormSection';
import AnswerSection from './components/AnswerSection';

import { useState } from 'react';

const App = () => {
  const configuration = new Configuration({
    apiKey: "sk-or-vv-c919463fedd3824481ef31071089d6bc3a08c27db395a2a90d670a829e41c52e",
    basePath: "https://api.vsegpt.ru:6070/v1",
  });

  const openai = new OpenAIApi(configuration);

  const [storedValues, setStoredValues] = useState([]);
  const [assistantMessages, setAssistantMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateResponse = async (newQuestion, setNewQuestion) => {
    if (newQuestion.trim().length === 0) {
      return;
    }
    if (!isLoading) {
      setIsLoading(true); 

      const headers = {
        "X-Title": "18ai-test",
      };
      const sysPrompt = process.env.REACT_APP_SYSTEM_PROMPT;
      const messages = [
        ...assistantMessages,
        { role: "user", content: newQuestion },
      ];

      try {
        const completion = await openai.createChatCompletion({
          model: "openai/gpt-3.5-turbo-0125",
          temperature: 0.4,
          top_p: 1,
          presence_penalty: 0.7,
          frequency_penalty: 1, 
          messages: [
            { role: "system", content: sysPrompt },
            ...messages,
          ],
        }, {
          headers: headers,
        });
        
        if (completion.data.choices) {
          const newValues = [
            {
              question: newQuestion,
              answer: completion.data.choices[0].message.content,
            },
            ...storedValues,
          ];
          setStoredValues(newValues);
          setAssistantMessages([
            ...messages,
            { role: "assistant", content: completion.data.choices[0].message.content },
          ]);
          setNewQuestion('');
          setIsLoading(false);
        }
      } catch (error) {
        console.error(error);
        let errorMessage = "";
        if (error.message.includes("403")) {
          errorMessage = `Упс! Нейросеть восприняла ваш запрос, как запрещённый для ответа.
          Такое происходит, когда ИИ считает ваш запрос связанным с самоповреждающим поведением, разжиганием ненависти, харрасментом и т.п.

          К сожалению, мы не можем напрямую влиять на то, как ИИ воспринимает отдельные слова/фразы.
          Попробуйте обновить страницу и переформулируйте запрос.
          Также вы можете дать пояснения для ИИ в самом запросе, например:
          Я практикующий психолог, тема ... интересует меня только в профессиональных целях, для публикаций. Дай для меня ответ на тему ...

          Если ничего не помогло, напишите в службу поддержки`;
        } else {
          errorMessage = `Ой, неведомая ошибка. Обновите страницу и повторите запрос.
          Если ошибка повторяется, напишите в службу поддержки`;
        }
        setError(errorMessage);
        setIsLoading(false);
      }
    }
  };

  return (
    <div>
      <div className="header-section">
        {storedValues.length < 1}
      </div>

      {/* Форма ввода вопроса */}
      <FormSection generateResponse={generateResponse} isLoading={isLoading} error={error}/> 

      {/* Отображение ответов */}
      {storedValues.length > 0 && <AnswerSection storedValues={storedValues} />}
    </div>
  );
};

export default App;
